import { Component } from 'react';
import "./GameViews/gameViews.css";
import { connect } from 'react-redux';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { setHeadersForFetch } from '../../objects/CommonUse/set_headers_for_fetch';
import getCurrentDateTime from '../../objects/CommonUse/get_current_date_time';
import FunStuffDataset from './datasets/fun_stuff_dataset';
import ImageCard from '../shared-components/image_card';
import { calcMonthlyIncome } from '../../objects/CommonUse/calcMonthlyIncome';
import BackgroundDataset from './datasets/backgroundDataset';
import ConfigFile from '../../datasets/config_file';
import { monthlyLoanAmt } from '../../objects/AssetsExpenses/loanAmtCalc_function';
import { calcNbrMonthsBtwnDates } from '../../objects/CommonUse/nbr_months_btwn_dates_calc';
import {buildUrl } from '../../objects/CommonUse/build_URL';
import Config from '../../config';
import { loanBalanceCalcFunction } from '../../objects/AssetsExpenses/loan_balance_calc_function';
import { findRemoveTableItem } from '../../objects/AssetsExpenses/find_remove_table_item';
import buildArrayForDisplay from '../../objects/CommonUse/build_array_for_display';
import TableDisplayCard from '../shared-components/table_display_card';
import { resetPicturesForChanges } from './objects/reset_pictureInfo_for_changes';
import createEventTrackerUpdateObject from '../../objects/CommonUse/create_eventTracker_update_object';
import updateSessionTokenStorage from '../../pages/Objects/update_session_token_storage';


// mapStateToProps: pick the Redux state your component needs
const mapStateToProps = (state) => ({
    gameData: state.gameData,
    funStuffInfo: state.funStuffInfo,
    eventConditions: state.eventConditions,
    pictureInfo: state.pictureInfo,
    rerender: false
  
    // add other Redux state slices here if needed
});


class SetupFunStuffModal extends Component {
    constructor(props) {
        super(props);
        this.gameData = JSON.parse(JSON.stringify(this.props.gameData));
        this.funStuffInfo = JSON.parse(JSON.stringify(this.props.funStuffInfo));
        this.eventConditions = JSON.parse(JSON.stringify(this.props.eventConditions));
        this.pictureInfo = JSON.parse(JSON.stringify(this.props.pictureInfo));

        this.state = {
            headers: setHeadersForFetch(),
            updateEnabled: false,
            openFriendModal: false,
            funStuffArr: FunStuffDataset,
            defaultClass: "medium-size-img ml-4 my-4 picture-border",
            currentDate: getCurrentDateTime().date,
            conditionalBackgrounds: BackgroundDataset,
            loanParms: ConfigFile.gameBoardLoans,
            subProcess: "setupFunStuffModal",
            environment: Config.dataURL.currentEnv,
            eventTracker: ConfigFile.general.eventTracker,
        }
        this.step = "";
        this.optionIndxArr = [];
        this.pictureArr = [];
        this.currentItem = null;
        this.loanRequired = false;
        this.depreciationPct = +ConfigFile.gameBoardLoans.depreciationPct;
        this.initializeFields();
    }

    initializeFields() {
        let feature = this.gameData.unlockedFeatures.find(elem => elem.featureName === "funStuff");
        for (let i = 0; i < this.state.funStuffArr.length; i++) {
            if (+feature.level >= +this.state.funStuffArr[i].level) {
                this.optionIndxArr.push(i);
            }
        }
        this.createPictureArrForType();
        updateSessionTokenStorage("setupFunStuff");
    }

    onClick(picturesList) {
        let buttonType = sessionStorage.getItem("funStuffButtonClicked");
        if (buttonType) {
            this.setUpdateType(buttonType, picturesList);
            sessionStorage.removeItem("funStuffButtonClicked");
        } else {
            this.processSelectedPicture(picturesList)
        }
        this.setState({rerender: !this.state.rerender});
    }

    setUpdateType(buttonSlctd, picturesList) {
        this.updateType = buttonSlctd;
        if (this.updateType === "decline") {
            this.typeIndx = this.state.funStuffArr.findIndex(elem => elem.type === picturesList.pictureText);
            this.funStuffType = this.state.funStuffArr[this.typeIndx];
            this.levelNbr = this.funStuffType.level; 
            this.saveFunStuffSelection();
        } else {
            if (this.updateType === "remove") {
                this.enterName = false;
            }
            this.processSelectedPicture(picturesList);
        }
    }

    processSelectedPicture(picturesList) {
        switch (picturesList.type) {
            case "Type":
                this.typeIndx = this.state.funStuffArr.findIndex(elem => elem.type === picturesList.pictureText);
                this.saveInfoForSelectedType();
                if (this.updateType === "remove" || this.updateType === "change") {
                    this.category = this.currentItem.category;
                    if (this.updateType === "remove") {
                        this.processSelectedItem();
                    } else {
                        this.createPictureArrForOptions();
                    }
                } else {
                    this.createPictureArrForOptions();
                }
                break;
            case "Option":
                let optionsArr = this.state.funStuffArr[this.typeIndx].options;
                this.optionIndx = optionsArr.findIndex(elem => elem.category === picturesList.pictureText);
                this.saveInfoForSelectedOption();
                this.createPictureArrForList();
                break;
            case "List":
                let listArr = this.funStuffOptions.list;
                this.listIndx = listArr.findIndex(elem => elem.type === picturesList.pictureText);
                this.processSelectedItem();
                break;
            default:
                break;

        }
    }

    saveInfoForSelectedType() {
        this.funStuffType = this.state.funStuffArr[this.typeIndx];
        this.inputType = this.funStuffType.input;
        this.levelName = this.funStuffType.type;
        this.levelNbr = this.funStuffType.level;
        this.modalTitle = this.funStuffType.type + " (Level " + this.funStuffType.level + ")";
        this.expItem = this.funStuffType.expItem;
        this.titleType = this.funStuffType.titleType;
        this.loanType = this.funStuffType.loanType;
        this.calcDepreciation = this.funStuffType.calcDepreciation;
        if (this.funStuffInfo.itemArr ){
            let funStuffItem = 
                this.funStuffInfo.itemArr.find(elem => elem.levelName === this.levelName);
            this.currentItem = funStuffItem;
        }
    }

    saveInfoForSelectedOption() {
        this.funStuffOptions = this.funStuffType.options[this.optionIndx];
        this.category = this.funStuffOptions.category;
    }

    createPictureArrForType() {
        this.pictureArr = [];
        for (let i = 0; i < this.optionIndxArr.length; i++) {
            let arrIndx = this.optionIndxArr[i];
            this.determineRequiredButtons(this.state.funStuffArr[arrIndx].type, arrIndx)
            let pictureObj = {
                type: "Type", 
                imageURL: "assets/" + this.state.funStuffArr[arrIndx].imageURL,
                disable: true, 
                imageClass: this.state.defaultClass, 
                pictureText: this.state.funStuffArr[arrIndx].type,
                buttonType: this.funStuffButtons
            };
            this.pictureArr.push(pictureObj);
        }
        this.step = "SelectType";
    }

    determineRequiredButtons(typeName) {
        let funStuffArr = [];
        if (this.funStuffInfo.itemArr) {
            funStuffArr = this.funStuffInfo.itemArr;
        }
        let funStuffIndx = funStuffArr.findIndex(elem => elem.levelName === typeName);
        if (funStuffIndx === -1) {
            this.funStuffButtons = "AddDecline";
        } else {
            this.previousItemType = funStuffArr[funStuffIndx].type;
            this.funStuffButtons = "ChangeRemove";

        }
    }

    createPictureArrForOptions() {
        let funStuffOptions = this.state.funStuffArr[this.typeIndx].options;
        this.pictureArr = [];
        if (funStuffOptions.length === 1) {
            if (this.step !== "Back") {
                this.optionIndx = 0;
                this.saveInfoForSelectedOption();
                this.createPictureArrForList();
            }
        } else {
            for (let i = 0; i < funStuffOptions.length; i++) {
                let pictureObj = {
                    type: "Option", 
                    imageURL: "assets/" + funStuffOptions[i].imageURL,
                    disable: false, 
                    imageClass: this.state.defaultClass, 
                    pictureText: funStuffOptions[i].category
                };
                this.pictureArr.push(pictureObj);

            }
            this.step = "SelectOption";
        }
    }

    createPictureArrForList() {
        this.pictureArr = [];
        this.newConditionName = this.state.funStuffArr[this.typeIndx].options[this.optionIndx].condName;
        this.categoryName = this.state.funStuffArr[this.typeIndx].options[this.optionIndx].category;
        let funStuffList = this.state.funStuffArr[this.typeIndx].options[this.optionIndx].list;
        if (funStuffList.length === 1) {
            if (this.step !== "Back") {
                this.listIndx = 0;
                this.processSelectedItem();
                this.step = "ItemSelected"
            } else {
                this.createPicturesForOptions();
            }
        } else {
            for (let i = 0; i < funStuffList.length; i++) {
                let disable = false;
                let pictureClass = this.state.defaultClass;
                if (this.currentItem &&
                    funStuffList[i].type === this.currentItem.type) {
                    disable = true;
                    pictureClass = this.state.defaultClass + " disabled-picture";
                }
                let pictureObj = {
                    type: "List", 
                    imageURL: "assets/" + funStuffList[i].image,
                    disable: disable, 
                    imageClass: pictureClass, 
                    pictureText: funStuffList[i].type
                };
                this.pictureArr.push(pictureObj);
            }
            this.step = "SelectItem";
        }
    }

    processSelectedItem() {
        if (this.updateType === "add" ||  this.updateType === "change"){
            this.funStuffItem = this.funStuffOptions.list[this.listIndx];
            this.ongoingAmts = this.funStuffItem.ongoingCosts;
            this.onetimeAmts = this.funStuffItem.onetimeCosts;
            this.selectItemType = this.funStuffItem.type;
            this.selectItemURL = "/assets/" + this.funStuffItem.image;
            this.itemText = this.funStuffItem.text;
        }else{
            this.ongoingAmts = {};
            this.onetimeAmts = {};
            this.selectItemURL = "/assets/" + this.currentItem.pictureURL;
        }
        if (this.updateType === "change" ||  this.updateType === "remove"){
            this.findReturnAmtsForCurrentItem();
        }else{
            this.returnAmts = {};
        }
        this.setTitleLit();
        this.totalMoodPoints = 0;
        switch(this.updateType){
            case "add":
                this.totalMoodPoints = 70;
                break;
            case "change":
                this.totalMoodPoints = -70;
                break;
            case "remove":
                this.totalMoodPoints = -140;
                break;
            default:
                break;
        }
        this.determineOneTimeCosts();
        this.determineOngoingCosts();
        this.step = "ItemSelected";
    }
  
    findReturnAmtsForCurrentItem(){
        const category = this.currentItem.category; 
        const currentType = this.state.funStuffArr.find(elem => elem.type === this.currentItem.levelName);
        const currentOptionArr = currentType.options;
        const currentOption = currentOptionArr.find(elem => elem.category === category);
        const currentListArr = currentOption.list;
        const currentList = currentListArr.find(elem => elem.type === this.currentItem.type);
        this.returnAmts = currentList.returnAmounts;
    }

    determineOneTimeCosts() {
        this.onetimeCostArr = [];
        this.returnCostArr = [];
        this.loanRequired = false;
        this.loanOutstandingAmt = 0;
        this.downPaymentAmt = 0;
        if (this.updateType === "change" || this.updateType === "remove") {
            if (this.loanType &&
                this.loanType !== "") {
                this.calculateCurrentLoanAmt();       
            }
        }
        this.loanAmtArr = [];
        this.oneTimeCostArr = [];
        if (this.updateType === "add" || this.updateType === "change") {
            if (this.funStuffItem.purchasePrice  &&
                +this.funStuffItem.purchasePrice !== 0){
                    this.determineLoanInfo();
            }
            let typeName = this.category + "OnetimeCosts";
            const onetimeCostObj = {...this.onetimeAmts, currentCash: +this.gameData.currentCash,
                downPayment: this.downPaymentAmt, loanOutstandingAmt: this.loanOutstandingAmt}
            this.onetimeCostArr = buildArrayForDisplay("FunStuff", typeName, onetimeCostObj);
            for (let i=0; i<this.onetimeCostArr.length; i++){
                if (this.onetimeCostArr[i].tableLine[1].fieldValue === "-"){
                    //  table line 0 contains the main field label
                    const tableFieldLine = this.onetimeCostArr[i].tableLine[0];
                    tableFieldLine.fieldValue = 
                        tableFieldLine.fieldValue + " (" + this.funStuffItem.type + ")";
                }
            }
        }
        if (this.updateType === "change" || this.updateType === "remove") {
            if (this.updateType === "remove"){
                this.buildTableLine("Current Cash", "", +this.gameData.currentCash);
                this.onetimeCostArr.push(this.tableLine);
                this.findReturnAmtsForCurrentItem();
            }            
            this.sellPrice = 0;
            if (this.calcDepreciation  && this.calcDepreciation === true){
                this.calculateSellPrice();
            }
            const prevItemCategory = this.currentItem.category
            const typeName = prevItemCategory + "ReturnCosts";
            const returnCostObj = {...this.returnAmts, sellPrice: this.sellPrice}  
            this.returnCostArr = buildArrayForDisplay("FunStuff", typeName, returnCostObj); 
            for (let i=0; i<this.returnCostArr.length; i++){
                this.onetimeCostArr.push(this.returnCostArr[i]);
            }
        }       
                
        this.totalOneTimeAmt = 0
        /*
         tableLine
            Array(3)
                 {fieldValue: 'Current Cash', fieldType: 'text', fieldClass: 'text-left font-weight-bold'}
                 {fieldValue: '', fieldType: 'text', fieldClass: 'text-center'}
                 {fieldValue: '26259.93', fieldType: 'amount', fieldClass: 'text-right'}
        */
        this.determineTotalAmt(this.onetimeCostArr);
        this.totalOneTimeAmt = this.totalAmount;
        this.buildTableLine("Total Cash After Change", "=", +this.totalAmount);
        this.onetimeCostArr.push(this.tableLine);
    }
    
    calculateCurrentLoanAmt() {
        this.loanOutstandingAmt = 0;
        const loanObj = findRemoveTableItem(this.gameData.loanTable, this.loanType, false, 
            "fullName");
        if (loanObj  && loanObj.loanNbrMonths > 0){
            this.loanOutstandingAmt = loanBalanceCalcFunction(loanObj.loanTotAmt, loanObj.loanIntRate,
                loanObj.loanAmt, loanObj.loanTerm, loanObj.loanNbrMonths);
            this.prevLoanPayment = +loanObj.loanAmt;
        }
        this.setState({loanRequired: true});
    }
    
    determineLoanInfo(){
        let downPaymentPct = this.state.loanParms.pctDownPayment;
        this.loanAmt = +this.funStuffItem.purchasePrice;
        this.totalLoanBeforeDownPayment = this.loanAmt - this.loanOutstandingAmt;
        this.downPaymentAmt = +(+this.funStuffItem.purchasePrice * +downPaymentPct).toFixed(2);
        this.totalLoanAmt = +this.totalLoanBeforeDownPayment - +this.downPaymentAmt;
        if (this.totalLoanAmt > this.gameData.currentCash ||
            this.totalLoanAmt > 10000){
                this.loanRequired = true;
                const boatLoanAmtObj = {downPayment: this.downPaymentAmt, 
                    boatPrice: +this.funStuffItem.purchasePrice, totalLoanAmt: this.totalLoanAmt};
                this.loanAmtArr = buildArrayForDisplay("FunStuff", "BoatLoanAmts", boatLoanAmtObj);
        }
    }

    calculateSellPrice(){
        let totNbrMonths = calcNbrMonthsBtwnDates(this.currentItem.startDate, 
            this.gameData.currentGameDate);
        let nbrYears = (+totNbrMonths / 12).toFixed(2);
        let purchasePrice = this.currentItem.purchasePrice;
        if (!purchasePrice){
            const loanObj = findRemoveTableItem(this.gameData.loanTable, "boatLoan", false);
            purchasePrice = loanObj.loanTotAmt;
        }
        let reducedAmt = +purchasePrice * +this.depreciationPct * +nbrYears + 2000;
        this.sellPrice = +purchasePrice - +reducedAmt;
    }

    determineOngoingCosts() {
        let incomeObj = calcMonthlyIncome(this.gameData.assetTable,
            this.gameData.expenseTable, this.gameData.loanTable);
        this.ongoingCostArr = [];
           
        if (this.updateType === "add" || this.updateType === "change") {
            this.prevLoanPayment = 0;
            this.monthLoanAmt = 0;
            if (this.loanRequired === true) {
                this.calculateOngoingLoanAmt();
            }
           
            const typeName = this.category + "MonthlyAmts";
            const ongoingCostObj = {...this.ongoingAmts, loanPayment: this.monthLoanAmt, 
                monthIncome: +incomeObj.income, prevLoanPayment: this.prevLoanPayment}
            this.ongoingCostArr = buildArrayForDisplay("FunStuff", typeName, ongoingCostObj  );
            for (let i=0; i<this.ongoingCostArr.length; i++){
                if (this.ongoingCostArr[i].tableLine[1].fieldValue === "-"){
                    const tableFieldLine = this.ongoingCostArr[i].tableLine[0];
                    tableFieldLine.fieldValue = 
                        tableFieldLine.fieldValue + " (" + this.funStuffItem.type + ")";
                }
            }
        }
        if (this.updateType === "change" || this.updateType === "remove") {
            if (this.updateType === "remove"){
                this.buildTableLine("Current Monthly Net Income", "", +incomeObj.income);
                this.ongoingCostArr.push(this.tableLine);
            }       
            let expenseTable = this.gameData.expenseTable;
            for (let i = 0; i < expenseTable.length; i++) {
                if (expenseTable[i].expItem === this.expItem && expenseTable[i].expNbrMonths !== 0) {
                    this.buildTableLine(expenseTable[i].expDesc, "+", +expenseTable[i].expAmount);
                    this.ongoingCostArr.push(this.tableLine);
                }
            }
        }
        this.determineTotalAmt(this.ongoingCostArr);
        this.buildTableLine("Monthly Net Income After Change", "=", this.totalAmount);
        this.buildNewOngoingCostArr();
        this.ongoingCostArr.push(this.tableLine);
    }

    calculateOngoingLoanAmt() {
        let totalLoanAmt = +this.loanAmt - +this.loanOutstandingAmt;
        let intRate = this.state.loanParms.intRate;
        let loanTerm = this.state.loanParms.loanTerm;
        let loanDesc = "Loan for " + this.funStuffItem.type;
        this.monthLoanAmt = monthlyLoanAmt(this.loanAmt, intRate, loanTerm);
        let loanNbrMonths = loanTerm * 12;
        this.newLoanObj = {
            loanType: this.loanType, loanDesc: loanDesc,
            loanAmt: this.monthLoanAmt, loanStartDate: this.gameData.currentGameDate,
            loanNbrMonths: loanNbrMonths, loanTotAmt: totalLoanAmt,
            loanIntRate: intRate, loanTerm: loanTerm
        };
    }

    determineTotalAmt(costArr){
        this.totalAmount = 0;
        for (let i=0; i<costArr.length; i++){
            let amount = +costArr[i].tableLine[2].fieldValue;
            if (costArr[i].tableLine[1].fieldValue === "-"){
                    amount = -1 * amount;
            }
        this.totalAmount += +amount;
        }
    }

    buildTableLine(fieldName, fieldSign, fieldValue){
        let tableArr = [];
        let tableObj = {};
        tableObj={fieldValue: fieldName, fieldType: "text", 
            fieldClass: "text-left font-weight-bold"}
        tableArr.push(tableObj);
        tableObj={fieldValue: fieldSign, fieldType: "text", fieldClass: "text-center"};
        tableArr.push(tableObj);
        tableObj={fieldValue: fieldValue, fieldType: "amount", fieldClass: "text-right"};
        if (fieldSign === "-"){
            tableObj.fieldClass += " text-danger";
        }
        tableArr.push(tableObj);
        this.tableLine={tableLine: tableArr};
    }

    buildNewOngoingCostArr(){
        this.newOngoingCostArr = []
        /*
        tableLine
        Array(3)
             {fieldValue: 'Current Cash', fieldType: 'text', fieldClass: 'text-left font-weight-bold'}
             {fieldValue: '', fieldType: 'text', fieldClass: 'text-center'}
             {fieldValue: '26259.93', fieldType: 'amount', fieldClass: 'text-right'}
             */
        for (let i=0; i<this.ongoingCostArr.length; i++){
             const ongoingCostTableLine = this.ongoingCostArr[i].tableLine;
             if (ongoingCostTableLine[1].fieldValue === "-"){
                  const ongoingCostObj = {label: ongoingCostTableLine[0].fieldValue,
                        amount: ongoingCostTableLine[2].fieldValue}
                  this.newOngoingCostArr.push(ongoingCostObj);
             }
        }
    }

    setTitleLit() {
        switch (this.updateType) {
            case "add":
                if (this.titleType === "animal") {
                    this.titleUpdateLit = "- Adopt a " + this.categoryName;
                } else {
                    this.titleUpdateLit = "- Purchase a " + this.categoryName;
                }
                break;
            case "change":
                if (this.titleType === "animal") {
                    this.titleUpdateLit = "- Surrender your " + this.currentItem.category + " and Adopt a new " + this.categoryName;
                } else {
                    this.titleUpdateLit = "- Sell your current " + this.currentItem.category + " and Purchase a new " + this.categoryName;
                }
                break;
            case "remove":
                if (this.titleType === "animal") {
                    this.titleUpdateLit = "- Surrender your " + this.currentItem.category;
                } else {
                    this.titleUpdateLit = "- Sell your " + this.currentItem.category;
                }
                break;
            default: 
                break;
        }
    }

    backButton() {
        if (this.updateType === "remove"){
            this.step = "SelectType";
        }else{
            switch (this.step) {
                case "SelectType":
                    this.props.onClose("back");
                    break;
                case "SelectOption":
                    this.step = "Back";
                    this.createPictureArrForType();
                    break;
                case "SelectItem":
                    this.step = "Back";
                    this.createPictureArrForOptions();
                    break;
                case "ItemSelected":
                    this.step = "Back";
                    this.createPictureArrForList();
                    break;
                default:
                    break;
            }
        }
        // if the next step is still back after this, then exit to the unlocked features selection
        if (this.step === "Back") {
            this.props.onNavigate("game-board");
        }
        this.setState({rerender: !this.state.rerender});
    }

    displayFriendModal() {
        this.askAFriendInfo = { topic: "setupSavings" }
        this.setState({openFriendModal: true});
    }

    closeFriendModal() {
        this.setState({openFriendModal: false});
    }

    render() {
        if (this.step === "SelectType" || this.step === "SelectOption" || 
            this.step === "SelectItem") {
            this.pictureDisplay = this.pictureArr.map((picturesList, key) =>
                <ImageCard imageInfo={picturesList} key={key}
                    disabled={this.state.disabled}
                    onClick={() => this.onClick(picturesList)}
                />
            );
        }
        if (this.step === "ItemSelected") {
            this.displayLoanAmts = this.loanAmtArr.map((amountArr,key) =>
                <TableDisplayCard key={key}  outInfo={amountArr}  />
            );
            this.displayOngoingAmts = this.ongoingCostArr.map((amountArr,key) =>
                <TableDisplayCard key={key}  outInfo={amountArr}  />
            );
            this.displayOnetimeAmts = this.onetimeCostArr.map((amountArr,key) =>
                <TableDisplayCard key={key}  outInfo={amountArr}  />
            );
        }
      
       
    return <>

        <Modal show={this.props.show} onHide={() => this.props.onClose("none")} size="lg" scrollable="true"
            dialogClassName={this.gutters} animation={false} >
            <Modal.Header className="backgroundTopBottom" closeButton>
                <Modal.Title className="text-center">Select Fun Stuff&nbsp; {this.titleUpdateLit}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="mx-4 my-4">
                    {this.step === "SelectType" || this.step === "SelectOption" || this.step === "SelectItem" ?
                        <div>
                            {this.step === "SelectType" ?
                                <div>Click on the button below the picture to select an item.</div>
                            :
                                <div>Click on the picture to select the fun stuff item that you would like to get.</div>
                            }
                            <div className="cursor-is-pointer">
                                {this.pictureDisplay}
                            </div>
                        </div>
                    :
                        null
                    }
                </div>

                {this.step === "ItemSelected" ?
                    <span>
                        {this.updateType !== "remove"  && this.itemText !== "" ?
                            <div>{this.itemText}</div>
                        :
                            null
                        }
                        {this.inputType === "name" && this.updateType !== "remove" ?
                            <div className="mt-2">
                                <label className="font-weight-bold" htmlFor="itemName">
                                        Pick a Name:&nbsp;&nbsp;</label>
                                <input type="text" className="col-med" id="itemName" name="itemName"></input>
                                <span className="text-danger">
                                        &nbsp;{this.nameError}</span>
                            </div>
                        :
                            null
                        }
                        <div className="text-left font-weight-bold ml-4 mx-0">
                                Total Mood Point Change:&nbsp; &nbsp; {this.totalMoodPoints}
                        </div>
                        <div className="row mt-4">
                            <div className="col-sm-7">
                                <table className="table-hover table-condensed table-wide">
                                    <tbody>
                                        {this.loanRequired === true ?
                                            <span>
                                                <tr>
                                                    <td className="mt-2 text-center font-weight-bold" colSpan='3'>
                                                    Loan Amounts
                                                    </td>
                                                </tr>
                                                {this.displayLoanAmts}
                                                <tr>
                                                    <td className="text-white font-weight-bold" colSpan="3">xxxxxx</td>
                                                </tr>
                                            </span>
                                        :
                                                null
                                        }
                                        <tr>
                                            <td className="mt-2 text-center font-weight-bold" colSpan='3'>
                                                Ongoing (Monthly) Costs
                                            </td>
                                        </tr>
                                            {this.displayOngoingAmts}
                                        <tr>
                                            <td className="text-white font-weight-bold" colSpan="3">xxxxxx</td>
                                        </tr>
                                        <tr>
                                            <td className="mt-2 text-center font-weight-bold"  colSpan='3'>
                                                One-Time Costs
                                            </td>
                                            </tr>
                                            {this.displayOnetimeAmts}
                                    </tbody>
                                </table>
                            </div>
                            <div className="col-sm-2"></div>
                            <div className="col-sm-3">
                            <div className="mt-4 text-white">xxxxxxx</div>
                            <div className="mt-4 text-white">xxxxxxx</div>
                            <img
                                src={this.selectItemURL}
                                className="funstuff-item-picture picture-border picture-container text-center" 
                                alt="ItemPicture" />
                            
                                <div className="font-weight-bold text-center">
                                    {this.selectItemType}
                                </div>
                            </div>
                        </div>
                    </span>
                :
                    null
                }


            </Modal.Body>
            <Modal.Footer className="backgroundTopBottom">
                <div className={this.msgClass}>{this.message}</div>
                    {this.step === "ItemSelected" ?
                        <span>
                            <Button className="mr-2" variant="secondary" onClick={() => this.editFormFields()} >
                                Submit
                            </Button>

                        </span>
                        :
                        null
                    }
                    <Button variant="dark" onClick={() => this.backButton()}>
                        Back
                    </Button>
                    <Button variant="primary" onClick={() => this.props.onClose("none")}>
                        Close
                    </Button>

                </Modal.Footer>
            </Modal>
        </>
    }

    editFormFields() {
        this.validData = true;
        if (this.updateType !== "remove") {
            if (this.inputType === "name") {
                this.itemName = document.getElementById("itemName").value;
                this.nameError = "";
                if (this.itemName === "") {
                    this.validData = false;
                    this.nameError = "Name cannot be blank.";
                }
            }
        }
        if (this.validData === true) {
            this.saveFunStuffSelection();
        }
        // create new router to update unlocked, icon, condition, cash, mood pts, expense, 
        // add mood point update to the unlocked features update (make chgs to other processes that use this router)
        // consider/add cost of getting rid of an item (both for change and remove)
    }

    saveFunStuffSelection() {
        if (this.updateType === "decline"){
            this.updateUnlockedFeatures();
            this.updatePlayerGameInfo();
        }else{
            this.prepareForGameUpdate();
            if (this.state.eventTracker === true){
                this.saveEventTracker();
            }
            this.buildGameObjForChangedData();
            this.updatePlayerGameInfo();
            this.updateFunStuffData();
            this.updatePictureInfo();
            this.props.checkUnlockedFeatures();
        }
        this.props.onClose("complete");
    }

prepareForGameUpdate(){
    this.cashAmt = (+this.totalOneTimeAmt).toFixed(2);
    this.moodPoints = this.gameData.currentMoodPoints;
    this.newExpenseTable = JSON.parse(JSON.stringify(this.gameData.expenseTable));
    this.newLoanTable = JSON.parse(JSON.stringify(this.gameData.loanTable));
    this.newConditionsTable = JSON.parse(JSON.stringify(this.gameData.conditionsTable));
    this.moodPoints = (+this.moodPoints + +this.totalMoodPoints);
    this.updateConditionTable();
    this.createNewExpenseTableObject();
    this.createNewLoanTableObject();
    this.updateUnlockedFeatures();
}
    
saveEventTracker(){
    const cashChg = (+this.cashAmt - +this.gameData.currentCash).toFixed(2);
    const funStuffChangeInfo = {unlockedFeature: "FunStuff",
         cashChg: cashChg.toString(),
         conditionTable: this.newConditionsTable,
         assetTable: this.gameData.assetTable, 
         expenseTable: this.newExpenseTable,
         loanTable: this.newLoanTable, 
         moodPoints: this.totalMoodPoints};
    const dataObject = createEventTrackerUpdateObject("UnlockedFeatures", 
        "SetUpFunStuff", this.gameData, funStuffChangeInfo, this.funStuffInfo);

    const funcName = "saveEventTracker";
    const urlParm = "";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch (uri,  
        {
        method:'post',
        headers: this.state.headers,
        body: JSON.stringify(dataObject)
        })
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                       // update of event tracker was successful
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message, errorObject: dataObject};
                        this.props.processError(errorObj);
                    }
                });
            };
        });
}

    buildGameObjForChangedData(){
        this.gameData.currentCash = this.cashAmt;
        this.gameData.currentMoodPoints = this.moodPoints;
        this.gameData.expenseTable = this.newExpenseTable;
        this.gameData.loanTable = this.newLoanTable;
        this.gameData.conditionsTable = this.newConditionsTable;
    }

    updatePlayerGameInfo() {
     
        this.props.setGameInfo(this.gameData, 'gameData');
        this.bodyObj = {
            "currentCash": this.gameData.currentCash,
            "currentMoodPoints": this.gameData.currentMoodPoints,
            "expenseTable": this.gameData.expenseTable,
            "loanTable": this.gameData.loanTable,
            "conditionsTable": this.gameData.conditionsTable,
            "unlockedFeatures": this.gameData.unlockedFeatures,
            "iconTable": this.gameData.iconTable,
        };
        const funcName = "updateGameInfoGeneral";
        const urlParm = "";
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri,  
            {
                method: 'PUT', headers: this.state.headers,
                body: JSON.stringify(this.bodyObj)
            })
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (statusCode === 200){
                    //  successful update of gameData
                }else{
                    const errorObj={function: funcName, subProcess: this.state.subProcess, 
                        status: statusCode, message: output.body.message, errorObject: this.bodyObj};
                    this.props.processError(errorObj);
                }
            });
            }
        });
    
    }
    
    updateConditionTable() {
        if (this.updateType === "remove" || this.updateType === "change") {
            let maxIndx = this.newConditionsTable.length - 1;
            for (let i = maxIndx; i >= 0; i--) {
                if (this.newConditionsTable[i].condName === this.currentItem.condName) {
                    this.newConditionsTable.splice(i, 1);
                    break;
                }
            }
        }
        if (this.updateType === "add" || this.updateType === "change") {
            let eventCondition = 
                this.eventConditions.find(elem => elem.condName === this.funStuffItem.condName);    
            let conditionObj = { condName: this.funStuffItem.condName,
                conditionClass: eventCondition.conditionClass, duration: -1 };
            this.newConditionsTable.push(conditionObj);
        }
    }

    createNewExpenseTableObject() {
        for (let i = 0; i < this.newExpenseTable.length; i++) {
            if (this.newExpenseTable[i].expItem === this.expItem &&
                +this.newExpenseTable[i].expNbrMonths !== 0) {
                this.newExpenseTable[i].expNbrMonths = 0;
            }

        }
        for (let i = 0; i < this.newOngoingCostArr.length; i++) {
            this.newExpenseObj = {
                expItem: this.expItem, expDesc: this.newOngoingCostArr[i].label,
                expAmount: this.newOngoingCostArr[i].amount, expStartDate: this.gameData.currentGameDate, 
                expNbrMonths: "-1", chargeCreditCard: true
            };
            this.newExpenseTable.push(this.newExpenseObj);
        }
    }

    createNewLoanTableObject() {
        for (let i = 0; i < this.newLoanTable.length; i++) {
            if (this.newLoanTable[i].loanType === this.loanType &&
                +this.newLoanTable[i].loanNbrMonths !== 0) {
                this.newLoanTable[i].loanNbrMonths = 0;
            }
        }
        if (this.loanRequired === true){
            this.newLoanTable.push(this.newLoanObj);
        }
    }
 
    updateUnlockedFeatures(){
        this.featureIndx = 
            this.gameData.unlockedFeatures.findIndex(elem => elem.featureName === "funStuff");
        let unlockedFeaturesObj = this.gameData.unlockedFeatures[this.featureIndx];
        if (+this.levelNbr < unlockedFeaturesObj.level){
             // if updating a level prior to current level, then no change should be made to unlocked features or icons!!!
        }else{
            let activeInactive = "none";
            if (+this.levelNbr === unlockedFeaturesObj.level){
                if (this.updateType === "add" || this.updateType === "change") {
                    activeInactive = "active";
                }
                if (this.updateType === "remove" || this.updateType === "decline"){
                    activeInactive = "inactive"
                }
                this.updateIconTable();
            }
            unlockedFeaturesObj.setup = activeInactive;
            this.gameData.unlockedFeatures[this.featureIndx] = unlockedFeaturesObj;
        }
    }

    updateIconTable(){
        let iconTable = this.gameData.iconTable;
        let startIdx = iconTable.length - 1;
        for (let i = startIdx; i >= 0; i--) {
            if (iconTable[i].iconName === "funStuff" ||
                iconTable[i].iconName === "funStuffReminder") {
                iconTable.splice(i, 1);
                break;
            }
        }
        this.gameData.iconTable = iconTable;
    }

    updateFunStuffData() {
        if (!this.funStuffInfo.gameID) {
            this.newFunStuffEntry = true;
        } else {
            this.newFunStuffEntry = false;
        }
        this.setBodyObj();
        this.updateFunStuff();

    }

    setBodyObj() {
        var dateCreated;
        if (this.newFunStuffEntry === true) {
            dateCreated = this.state.currentDate;
        } else {
            dateCreated = this.funStuffInfo.dateCreated;
        }

        if (this.updateType === "change" || this.updateType === "remove") {
     //       this.funStuffItem = "";
            let maxIndx = this.funStuffInfo.itemArr.length - 1;
            for (let i = maxIndx; i >= 0; i--) {
                if (this.funStuffInfo.itemArr[i].levelName === this.levelName) {
                    this.funStuffInfo.itemArr.splice(i, 1);
                }
            }
        }
        this.gameID = this.gameData._id;
        if (this.updateType === "add" || this.updateType === "change") {
            if (!this.funStuffInfo.itemArr) {
                let funStuffObj = {
                    gameID: this.gameID,
                    itemArr: [],
                    dateAdded: dateCreated,
                    dateUpdated: ""
                }
                this.funStuffInfo = funStuffObj;
            }
            this.funStuffItem = {
                levelName: this.levelName,
                levelNbr: this.levelNbr,
                category: this.categoryName,
                type: this.funStuffItem.type,
                name: this.itemName,
                condName: this.funStuffItem.condName,
                pictureLabel: this.funStuffItem.label,
                pictureURL: this.funStuffItem.image,
                backgroundURL: this.funStuffItem.backgroundURL,
                pictureClass: this.funStuffItem.imageClass,
                startDate: this.gameData.currentGameDate,
            }
            this.funStuffInfo.itemArr.push(this.funStuffItem);
        }
        this.funStuffInfo.dateUpdated = this.state.currentDate;
        this.props.setGameInfo(this.funStuffInfo, 'funStuffInfo');
    }

    updateFunStuff() {
        const funcName = "updateFunStuff";
        const urlParm = "?gameID=" + this.gameID;
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri,  
            {
                method: 'PUT', headers: this.state.headers,
                body: JSON.stringify(this.funStuffInfo)
            })
            .then(response => {
                if (response.ok){
                    response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        // "update fun stuff was successful"
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message, errorObject: this.funStuffInfo};
                        this.props.processError(errorObj);
                    }
                });
            }
            });
    }

    updatePictureInfo() {
        const newPictureInfo = resetPicturesForChanges("funStuff", this.pictureInfo, "",
            "", "", "", this.funStuffInfo);
        this.props.setGameInfo(newPictureInfo, 'pictureInfo');
    }

}

export default connect(mapStateToProps)(SetupFunStuffModal);

